var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"ml-1",attrs:{"dark":"","color":"primary","x-small":"","fab":"","outlined":""},on:{"click":function($event){return _vm.action(_vm.data, 'information')}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("mdi-information")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }